module.exports = __webpack_public_path__ + "static/img/boat-4.5b610a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boat-4.png
// module id = HJN3
// module chunks = 0